import { Navigate, Outlet } from "react-router-dom"
import { observer } from "mobx-react-lite"
import AuthStore from "../../stores/AuthStore"

export const Protected = observer(() => {
	const { isLoggedIn } = AuthStore

	if (!isLoggedIn) {
		return <Navigate to="/login" />
	}
	return <Outlet />
})
